<template>
  <header>
    <div class="header">
      <div class="header__content">
        <icon
          :name="showMenu ? 'arrow-left': 'menu'"
          class="header__mobil-menu"
          @click="showMenu = !showMenu"
        ></icon>
        <div class="header__left">
          <router-link to="/" class="header__logo" @click.native="showMenu = false"></router-link>
          <navigation :showMenu="showMenu" @close="showMenu = false"></navigation>
        </div>
        <div class="header__right">
          <div class="header__contact">
            <span>Rufen Sie an!</span>
            <span>0176 834 915 08</span>
          </div>
          <router-link
            tag="button"
            to="/login"
            class="header__login"
            @click.native="showMenu = false"
          >Login</router-link>
          <router-link tag="div" to="/login" class="icon icon-user header__login-mobile"></router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Navigation from "../navigation/Navigation";
import Icon from "../../../core/components/icon/Icon";

export default {
  name: "Header",
  data: () => ({
    showMenu: false
  }),
  props: {
    msg: String
  },
  components: {
    Navigation,
    Icon
  }
};
</script>

<style scoped lang="scss">
header {
  height: 64px;
  width: 100%;
  position: relative;
}

.header {
  background-color: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 48px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  height: 64px;
  z-index: 150;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    box-shadow: 0 4px 40px -20px rgba(13, 13, 13, 0.2);
    pointer-events: none;
    z-index: 101;
  }
}

.header__mobil-menu {
  display: none;
  color: #999999;
  cursor: pointer;
}

.header__content {
  width: 1024px;
  margin: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.header__left,
.header__right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.header__logo {
  width: 42px;
  height: 28px;
  background-image: url("../../../assets/auszeit-logo.svg");
  background-size: contain;
}

.header__contact {
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-size: 16px;
  letter-spacing: 0.2px;
  color: #999999;

  > span:last-child {
    //font-family: Soleil;
    font-family: Lato;
    font-weight: normal;
    margin-left: 8px;
  }
}

.header__login {
  border-radius: 4px;
  border: solid 2px #0d0d0d;
  line-height: 16px;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.7px;
  text-align: center;
  color: #0d0d0d;
  text-transform: uppercase;
  margin-left: 16px;
  padding: 4px 8px;
  display: none;
}

.header__login-mobile {
  display: none;
  color: #999999;
  opacity: 0;
}

@media (max-width: 1023px) {
  .header__contact {
    display: none;
  }
}

@media (max-width: 767px) {
  .header {
    padding: 0 24px;
  }

  .header__mobil-menu {
    display: block;
  }

  .header__login {
    display: none;
  }

  .header__login-mobile {
    display: block;
  }
}
</style>
